// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__mBpPN","signatureBlock":"Footer_signatureBlock__-6TQ4","signature":"Footer_signature__ckJQh"};